import { SelectionModel } from '@angular/cdk/collections';
import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { debounceTime, Subject } from 'rxjs';
import { ICardConfigResponsive } from 'src/app/domain/ICardConfigResponsive';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { ITableResponsive } from 'src/app/domain/ITableResponsive';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { S3_URL_BASE } from 'src/environments/environment';
import { GlobalUtils } from '../../global-utils';
import { KeyboardService } from '../keyboard/keyboard.service';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';

@Component({
    selector: 'card-grid-responsive',
    styleUrls: ['card-grid-responsive.component.sass'],
    templateUrl: 'card-grid-responsive.component.html',
})
export class CardGridResponsive
    implements OnInit, AfterViewInit, ITableResponsive, OnChanges {
    @Input() currentTab: string = '';
    @Input() userType: string = '';
    isSelectAllChecked: boolean = false;
    s3UrlBase = S3_URL_BASE;

    constructor(public keyboardService: KeyboardService) { }

    @Input() showViewButton: boolean = false;
    @Output() view = new EventEmitter<any>();
    @Input() showEditButton: boolean = false;
    @Output() edit = new EventEmitter<any>();
    public selectedItems: any[] = [];
    public item: any = null;

    @Input() isEditableShow: boolean = true;
    @Input() isEditableEnabled: boolean = true;

    @Input() isDeletableShow: boolean = true;
    @Input() isDeletableEnabled: boolean = true;

    @Input() isLockActionShow: boolean = true;
    @Input() isLockActionEnabled: boolean = true;

    @Input() hasFilter: boolean = true;
    @Input() lockProperty: string = '';
    @Input() lockPeopleProperty: string = '';
    @Input() infoProperty: string = '';
    @Input() showLock: boolean = false;
    @Input() showPeopleLock: boolean = false;
    @Input() showInfo: boolean = false;
    @Input() showKey: boolean = false;
    @Input() showDashboardButton: boolean = false;
    @Input() hasAdd: boolean = true;
    @Input() type: TypeIndexEnum = TypeIndexEnum.CRUD;
    @Input() length: number = 0;
    @Output() changePage: EventEmitter<any> = new EventEmitter<any>();
    @Output() filter: EventEmitter<any> = new EventEmitter<any>();
    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
    @Output() onSelectionChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() openLink: EventEmitter<string> = new EventEmitter<string>();
    @Input() showDownload: boolean = false;
    @Input() downloadProperty: string = '';
    @Input() qrcode: string = '';
    @Output() download: EventEmitter<any> = new EventEmitter();
    @Output() cancelDownload = new EventEmitter<any>();
    @Input() showDescription: boolean = false;
    @Input() descriptionProperty: string = '';
    @Output() description = new EventEmitter<any>();
    @Input() showCancelOrder: boolean = false;
    @Input() cancelOrderProperty: string = '';
    @Output() cancelorder = new EventEmitter<any>();
    @Input() statusProperty: string = '';
    @Output() status = new EventEmitter<any>();
    @Output() whatsApp = new EventEmitter<any>();
    @Output() email = new EventEmitter<any>();
    @Output() birthday = new EventEmitter<any>();
    keyboardChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() cardTitleProperty: string = ''; // Propriedade para o título do card
    @Input() cardSubtitleProperty: string = ''; // Propriedade para o subtítulo do card
    @Input() cardImageProperty: string = ''; // Propriedade para a imagem do card

    // Propriedades para configuração visual dos cards
    @Input() cardsPerRow: number = 3; // Número de cards por linha
    @Input() cardMinWidth: string = '280px'; // Largura mínima do card
    @Input() showBadge: boolean = false; // Exibir badge no card
    @Input() badgeProperty: string = ''; // Propriedade para o badge
    @Input() placeholderImageFallback: string = 'P'; // Imagem de placeholder padrão

    @Input() isLoading: boolean = false; // Indicador de carregamento

    @Input() set initialFilterValue(value: string) {
        if (value) {
            this.filterValue = value;
        }
    }

    filterValue: string = '';
    @Input() showPlayButton: boolean = false;
    @Input() showPdfButton: boolean = false;
    @Input() showAprovedButton: boolean = false;
    @Input() showPendingButton: boolean = false;
    @Input() showRejectedButton: boolean = false;
    @Input() showCanceledButton: boolean = false;
    @Input() showAnalysisButton: boolean = false;
    @Input() showOpenChatButton: boolean = false;
    @Input() showWhatsApp = false;
    @Input() showEmail = false;
    @Input() showBirthday = false;
    @Input() showActivities = false;
    @Input() birthdayFilter: (contact: any) => boolean;
    @Output() openChatEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() activities = new EventEmitter<any>();

    @Input() showBriefingActions: boolean = false;
    @Output() openBriefingQrCode: EventEmitter<any> = new EventEmitter();
    @Output() openBriefingForm: EventEmitter<any> = new EventEmitter();

    pageSize = 12;
    pageSizeOptions: number[] = [12, 24, 48, 96];
    selection = new SelectionModel<any>(true, []);

    @Input() showContractsButton = false;
    @Output() openContractsModal: EventEmitter<any> = new EventEmitter<any>();

    @Output() statusFilter = new EventEmitter<string>();

    @Input() actions = [];
    @Input() filters = [];
    @Input() search = true;

    @Output() add = new EventEmitter<boolean>();
    @Output() remove = new EventEmitter<any>();
    @Output() detail = new EventEmitter<any>();

    @Input() showStatus = false;
    @Output() toggleStatus = new EventEmitter<any>();

    @Output() key: EventEmitter<any> = new EventEmitter();
    @Output() dashboard: EventEmitter<any> = new EventEmitter();
    @Output() play: EventEmitter<any> = new EventEmitter();
    @Output() openPdf: EventEmitter<any> = new EventEmitter();

    @Input() loadingDownloads: { [key: string]: boolean } = {};
    @Input() loadingProgress: { [key: string]: number } = {};
    @Input() data: any[] = [];

    // Propriedade para item selecionado no layout de cards
    selectedItem: any = null;

    private filterSubject = new Subject<string>();

    // Adicionando a configuração de card
    @Input() cardConfig: ICardConfigResponsive;

    @Input() showCustomButton: boolean = false;
    @Input() customButtonIcon: string = 'dashboard'; // Ícone padrão
    @Input() customButtonTooltip: string = 'Ação Personalizada';
    @Input() customButtonColor: string = 'primary';
    @Output() customButtonClick = new EventEmitter<any>();

    // Total de itens ativos e inativos (para contagem geral)
    private totalActiveItems: number = 0;
    private totalInactiveItems: number = 0;

    // Adicionar propriedade para controlar o filtro ativo/inativo
    activeFilter: 'active' | 'inactive' = 'active';

    // Adicionar propriedade para manter os dados originais
    private _originalData: any[] = [];

    // Função para obter o valor de um campo de um objeto
    getObjectProperty(object: any, property: string): any {
        if (property.includes('.')) {
            const parts = property.split('.');
            let value = object;
            for (const part of parts) {
                if (value && value[part] !== undefined) {
                    value = value[part];
                } else {
                    return null;
                }
            }
            return value;
        }
        return object[property];
    }

    // Função para verificar se um item está selecionado
    isItemSelected(item: any): boolean {
        if (this.isSelectAllChecked) return true;
        return this.selection.isSelected(item);
    }

    // Função para selecionar um item no layout de cards
    selectItem(item: any): void {
        // Se a tecla CTRL estiver pressionada ou já for uma seleção múltipla, permitir seleção múltipla
        if (this.cardConfig?.selectable) {
            this.toggleSelection(item);
        } else {
            // Caso contrário, comportamento de seleção única
            this.selectedItem = item;
            this.onSelect.emit(item);
        }
    }

    // Função para gerar placeholder para imagem
    getImagePlaceholder(item: any): string {
        if (this.cardTitleProperty && item[this.cardTitleProperty]) {
            return item[this.cardTitleProperty][0].toUpperCase();
        }
        return this.placeholderImageFallback;
    }

    ngOnInit(): void {
        this.keyboardChange.subscribe((event) => {
            this.applyFilter(event);
        });

        this.filterSubject.pipe(
            debounceTime(500)
        ).subscribe((value) => {
            const filtroValido = value || '';
            this.filter.emit(filtroValido.toUpperCase());
        });

        // Aplicar filtro inicial para mostrar apenas ativos
        this.applyActiveFilter('active');
    }

    public pageEvent(event: PageEvent): PageEvent {
        // Atualizar o tamanho da página antes de emitir o evento
        this.pageSize = event.pageSize;
        this.changePage.emit({ page: event.pageIndex, limit: event.pageSize });
        return event;
    }

    setPageSizeOptions(setPageSizeOptionsInput: string) {
        if (setPageSizeOptionsInput) {
            this.pageSizeOptions = setPageSizeOptionsInput
                .split(',')
                .map((str) => +str);
        }
    }

    @ViewChild(MatPaginator)
    paginator!: MatPaginator;
    @ViewChild(MatSort)
    sort: MatSort = new MatSort();

    @Input('hideFilter') hideFilter: boolean;
    @Input('hidePagination') hidePagination: boolean;
    @Input('displayedColumns')
    displayedColumns: string[];
    @Input('displayedColumnsOnDetail')
    displayedColumnsOnDetail: string[];
    @Input('dataSource')
    set dataSource(value: MatTableDataSource<any>) {
        if (value) {
            // Guardar os dados originais
            this._originalData = value.data;

            // Aplicar o filtro inicial para mostrar apenas ativos
            const filteredData = value.data.filter(item =>
                item[this.lockProperty] !== false && item.isActive !== false
            );

            // Criar novo MatTableDataSource com os dados filtrados
            this._dataSource = new MatTableDataSource<any>(filteredData);

            // Atualizar contadores usando os dados originais
            this.updateTotalCounts(this._originalData);
        }
    }

    get dataSource(): MatTableDataSource<any> {
        return this._dataSource;
    }

    private _dataSource: MatTableDataSource<any>;
    @Input('configColumns')
    configColumns: IColumnConfigTableResponsive[];

    @Output() openShow: EventEmitter<any> = new EventEmitter();
    @Output() openNew: EventEmitter<any> = new EventEmitter();
    @Output() openEdit: EventEmitter<any> = new EventEmitter();
    @Output() openDelete: EventEmitter<any> = new EventEmitter();
    @Output() lock: EventEmitter<any> = new EventEmitter();
    @Output() unlock: EventEmitter<any> = new EventEmitter();
    @Output() lockPeople: EventEmitter<any> = new EventEmitter();
    @Output() unlockPeople: EventEmitter<any> = new EventEmitter();
    @Output() infoAction: EventEmitter<any> = new EventEmitter();
    @Output() playAction: EventEmitter<any> = new EventEmitter();
    @Output() openPdfAction: EventEmitter<any> = new EventEmitter();

    ngAfterViewInit() {
        if (!this.dataSource) {
            this.dataSource = new MatTableDataSource<any>([]);
        }
    }

    applyFilter(value: string) {
        if (value !== undefined && value !== null) {
            this.filterSubject.next(value);
        } else {
            this.filterSubject.next('');
        }
    }

    /**
     * Alterna o estado "Selecionar Todos".
     * Não manipula mais todos os itens no SelectionModel diretamente.
     */
    masterToggle(): void {
        this.isSelectAllChecked = !this.isSelectAllChecked;
        if (this.isSelectAllChecked) {
            this.selection.clear();
            this.onSelectionChange.emit({ selectAll: true });
        } else {
            this.selection.clear();
            this.onSelectionChange.emit({ selectAll: false, items: [] });
        }
    }

    toggleAllRows(): void {
        if (this.dataSource && this.dataSource.data) {
            this.masterToggle();
        }
    }

    get typeIndexEnum() {
        return TypeIndexEnum;
    }

    public getUrl(value: string) {
        return `${S3_URL_BASE}${value}`;
    }

    downloadFile(url: string): void {
        window.open(url, '_blank');
    }

    descriptionFile(element: any): void {
        this.description.emit(element);
    }

    onCancelReason(element: any): void {
        this.cancelorder.emit(element);
    }

    playRow(element: any): void {
        this.play.emit(element);
    }

    // Método específico para o layout de cards
    toggleSelection(item: any): void {
        if (this.isSelectAllChecked) {
            this.isSelectAllChecked = false;
            this.selection.clear();
        }

        this.selection.toggle(item);
        this.onSelectionChange.emit({ selectAll: false, items: this.selection.selected });
    }

    // Método para verificar se todos os itens estão selecionados
    isAllSelected(): boolean {
        return this.isSelectAllChecked;
    }

    // Método para verificar se está no estado indeterminado
    isMasterCheckboxIndeterminate(): boolean {
        return !this.isSelectAllChecked && this.selection.hasValue();
    }

    // Método para verificar se o componente tem configuração para seleção
    hasSelectConfig(): boolean {
        return this.cardConfig?.selectable === true ||
            (this.displayedColumns && this.displayedColumns.includes('select')) ||
            false;
    }

    // Modificar a função getValue para lidar com config undefined
    // Função que obtém o valor apropriado para exibir no card
    getValue(config: IColumnConfigTableResponsive | null, item: any): any {
        if (!config || !item) return '';

        // Para campos booleanos (flags) formatados como Sim/Não
        if (config.field_type === FieldTypeEnum.LABEL_FLAG) {
            const value = item[config.property];
            if (value === true) {
                return '<span style="color: #198754;">Sim</span>';
            } else if (value === false) {
                return '<span style="color: #dc3545;">Não</span>';
            }
            return 'N/A';
        }

        return GlobalUtils.getValueByTypeColumnTableResponsive(config, item[config.property]);
    }

    // Função para obter colunas/propriedades mais importantes para mostrar nos cards
    getPrimaryProperties(): string[] {
        if (this.configColumns && this.configColumns.length > 0) {
            // Retorna todas as propriedades exceto 'actions' e 'select'
            return this.displayedColumns
                .filter(col => col !== 'actions' && col !== 'select' &&
                    col !== 'image' && col !== this.cardImageProperty);
        }
        return [];
    }

    // Retorna a configuração da coluna para uma propriedade específica
    getConfigForProperty(property: string): IColumnConfigTableResponsive | null {
        const config = this.configColumns?.find(config => config.property === property);
        return config || null;
    }

    // Funções de ação
    showRow(element: any): void {
        this.openShow.emit(element);
    }

    editRow(element: any): void {
        this.openEdit.emit(element);
    }

    deleteRow(element: any): void {
        this.openDelete.emit(element);
    }

    lockItem(element: any): void {
        this.lock.emit(element);
    }

    unlockItem(element: any): void {
        this.unlock.emit(element);
    }

    infoItem(element: any): void {
        this.infoAction.emit(element);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['dataSource'] && !changes['dataSource'].firstChange) {
            const data = changes['dataSource'].currentValue;
            if (Array.isArray(data)) {
                // Guardar dados originais
                this._originalData = data;

                // Aplicar o filtro atual
                this.applyActiveFilter(this.activeFilter);
            } else if (data && Array.isArray(data.data)) {
                // Guardar dados originais
                this._originalData = data.data;

                // Aplicar o filtro atual
                this.applyActiveFilter(this.activeFilter);
            } else if (data) {
                this._originalData = [];
                this._dataSource = new MatTableDataSource<any>([]);
                this.updateTotalCounts([]);
                console.warn('CardGridResponsive: dataSource deve ser um array');
            }
        }
    }

    // Obtém o valor da primeira propriedade primária
    getPrimaryPropertyValue(item: any): string {
        const primaryProps = this.getPrimaryProperties();
        if (primaryProps.length > 0) {
            const firstProp = primaryProps[0];
            const config = this.getConfigForProperty(firstProp);
            if (config) {
                return this.getValue(config, item) || '';
            }
            return item[firstProp] || '';
        }
        return '';
    }

    // Métodos para contar itens ativos e desativados
    getActiveItemsCount(): number {
        return this.totalActiveItems;
    }

    getInactiveItemsCount(): number {
        return this.totalInactiveItems;
    }

    // Modificar updateTotalCounts para sempre usar _originalData
    updateTotalCounts(data: any[]) {
        if (!data) {
            this.totalActiveItems = 0;
            this.totalInactiveItems = 0;
            return;
        }

        this.totalActiveItems = data.filter(item =>
            item[this.lockProperty] !== false && item.isActive !== false
        ).length;

        this.totalInactiveItems = data.filter(item =>
            item[this.lockProperty] === false || item.isActive === false
        ).length;
    }

    // Adicionar método para alternar filtro ativo/inativo
    toggleActiveFilter(filter: 'active' | 'inactive'): void {
        this.activeFilter = filter;
        this.applyActiveFilter(filter);
    }

    // Método para aplicar o filtro
    private applyActiveFilter(filter: 'active' | 'inactive'): void {
        if (!this._originalData) return;

        let filteredData;
        if (filter === 'active') {
            filteredData = this._originalData.filter(item =>
                item[this.lockProperty] !== false && item.isActive !== false
            );
        } else {
            filteredData = this._originalData.filter(item =>
                item[this.lockProperty] === false || item.isActive === false
            );
        }

        // Atualizar o dataSource com os dados filtrados
        if (this._dataSource) {
            this._dataSource.data = filteredData;
        } else {
            this._dataSource = new MatTableDataSource<any>(filteredData);
        }

        // Atualizar contadores usando os dados originais
        this.updateTotalCounts(this._originalData);
    }
} 